export const CURRENT_USER = "current_user";

export const USER_TYPE = {
  CHEF: "CHEF",
  USER: "USER"
  
};
